import {
  GET_LEADS_SUCCESS,
  GET_LEADS_FAIL,
  CREATE_LEAD_SUCCESS,
  CREATE_LEAD_FAIL,
  UPDATE_LEAD_SUCCESS,
  UPDATE_LEAD_FAIL,
  GET_LEADS_ENVIADOS,
  SEND_LEAD_SUCCESS,
  SEND_LEAD_FAIL,
  CLEAR_SEND_LEAD_RESULT
} from "./actionTypes"

const INIT_STATE = {
  lead: {},
  leads: [],
  sendResult: null,
  resultLead: null,
  error: {},
}


const leads = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEADS_ENVIADOS:
      return {
        ...state,
        leads: action.payload,
      }

    case GET_LEADS_SUCCESS:
      return {
        ...state,
        leads: action.payload,
      }

    case GET_LEADS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      
    case CREATE_LEAD_SUCCESS:
      return {
        ...state,
        lead: action.payload,
      }

    case CREATE_LEAD_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    case UPDATE_LEAD_SUCCESS:
      return {
        ...state,
        lead: action.payload, // mantém o último lead “corrente”
        leads: state.leads.map(l =>
          (l?.Id || l?.id) === (action.payload?.Id || action.payload?.id)
            ? action.payload
            : l
        ),
      }

    case UPDATE_LEAD_FAIL:
        return {
            ...state,
            error: action.payload,
        };

    case SEND_LEAD_SUCCESS:
      return {
        ...state,
        resultLead: action.payload,
        error: {}
      };


    case SEND_LEAD_FAIL:
      return {
          ...state,
          resultLead: action.payload,
          error: action.payload,
        };

    case CLEAR_SEND_LEAD_RESULT:
      return {
        ...state,
        resultLead: null,
      }

    default:
      return state
  }
}

export default leads
